export default "__VITE_ASSET__rfSXoSWz__"